import React, { useEffect } from "react";
import { connect } from "react-redux";


const PendingApprovalsTable = (props) => {

const {otHours, fromDate, reason, dateRequested} = props;

	
return (
	<div>
    <div className="flex justify-between items-center bg-yellow-50 border border-yellow-200 rounded-xl mt-2 p-3 text-sm text-gray-700">
      <div className="flex-1">
        <p className="text-md text-gray-700 font-semibold">Overtime Hours</p>
      </div>
        {otHours && (
          <p className="font-semibold text-lg text-red-700">{otHours}h</p>
        )}
    </div>

    <div className="flex justify-between items-center bg-gray-50 rounded-xl mt-2 p-2 text-gray-700">
      <div className="flex-1">
        <p className="text-xs text-gray-500">DATE</p>
        <p className="font-semibold text-gray-900">{fromDate}</p>
      </div>
    </div>

    <div className="flex justify-between items-center bg-gray-50 rounded-xl mt-2 p-2 text-gray-700">
      <div className="flex-1">
        <p className="text-xs text-gray-500">REASON</p>
        <p className="text-gray-900">{reason}</p>
      </div>
    </div>
    <p className="text-xs text-gray-500 mt-1">Requested on {dateRequested}</p>

  </div>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingApprovalsTable);
